import { IVehicle } from "./vehicle.type";

export enum REPOSSESSION_STATUS {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  SUSPENDED = "SUSPENDED",
  CANCELED = "CANCELED",
}
export enum REPOSSESSION_REASON {
  NON_PAYMENT = "NON-PAYMENT",
  OTHER = "OTHER",
}

export type IRepossessionNote = {
  text: string;
  date: Date;
  author: string;
  currentPath: string;
};
export type IRepossession = {
  _id?: string;
  reason: string;
  notes: IRepossessionNote[];
  notesDetails: IRepossessionNote[];
  vehicle: IVehicle;
  collector: ICollector;
  renterId: string;
  renterName: string;
  repossessionStatus: "PENDING" | "COMPLETED" | "SUSPENDED";
  repossessionReason: "NON-PAYMENT" | "OTHER";
  repossessionNotes: string;
  repossessionStartedAt: Date;
  repossessionCompletedAt: Date | null;
  suspended: boolean;
  suspendedNote: string | null;
};

export type IRepossessionReceivables = {
  vehicle: IVehicle;
  city: string;
  vehicleInBase: boolean;
  renterId: string;
  renterName: string;
  renterWhatsapp: string;
};

export type IDebitmanagment = {
  _id?: string;
  companyId: string;
  renter: IRenter;
  daysOverdue: number;
  amount: number;
  status: NegotiationStatus;
  negotiations?: INegotiations[];
  createdAt?: Date;
  updatedAt?: Date;
};

export type IRenter = {
  id?: string;
  name?: string;
  whatsapp?: string;
  cpf?: string;
  licensePlate?: string;
  companyId?: string;
  vehicleId?: string;
  partnerId?: string;
};

export type ICollector = {
  id?: string;
  name?: string;
  whatsapp?: string;
  pixKey?: string;
  pixKeyType?: string;
  payed?: boolean;
};

export enum NegotiationStatus {
  PENDING = "PENDING",
  IN_NEGOTIATION = "IN_NEGOTIATION",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}

export type INegotiations = {
  _id?: string;
  total: number;
  createdAt: Date;
  updatedAt: Date;
  paymentNegotiations: IPaymentInstallment[];
  callCenterInteractions?: ICallInteraction[];
};

export type IPaymentInstallment = {
  _id?: string;
  description: string;
  individualAmountPayment: number;
  paymentDate: string;
};

export type ICallInteraction = {
  _id?: string;
  interactionId?: string;
  notes?: string;
  contactDate: Date;
  author?: string;
  createdAt?: Date;
  updatedAt?: Date;
};
